export default __webpack_public_path__ + "static/media/meditationCard.a1be4b0d.png";